import { checkASCII } from './Ansi';

export const NAME_ERRORS = {
  REQUIRED: 'required',
  MIN_LENGTH: 'minLength',
  MAX_LENGTH: 'maxLength',
  CHECK_ASCII: 'checkASCII',
};

export const validateName = (name, maxLength, minLength, isRequired = true) => {
  const currentErrors = [];

  if (!name && isRequired) {
    currentErrors.push(NAME_ERRORS.REQUIRED);
  }

  if (isRequired && !checkASCII(name)) {
    currentErrors.push(NAME_ERRORS.CHECK_ASCII);
  }

  if (name && name.length > maxLength) {
    currentErrors.push(NAME_ERRORS.MAX_LENGTH);
  }

  if (name && name.length < minLength) {
    currentErrors.push(NAME_ERRORS.MIN_LENGTH);
  }

  return {
    isValid: currentErrors.length === 0,
    errors: currentErrors,
  };
};
